import React, {Fragment, useEffect, useState} from "react";
import {s_char, s_char_disciplines, s_char_matrices, s_char_talents} from "../../_signals/s_char";
import Charcreate from "../../_helper/charcreate";
import {DisziplineTalents} from "./DisziplineTalents";
import DialogContent from "@mui/material/DialogContent";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {ICharDiscipline} from "../../_interfaces/ICharDiscipline";
import {getBaseCharUpd} from "../../_signals/s_char_calc";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import Select from "@mui/material/Select";
import {TalentsCreate, TalentsUpdate} from "../../_api/BETalents";
import {DisciplinesUpdate} from "../../_api/BEDisciplines";
import {MatricesUpdate} from "../../_api/BEMatrices";
import {raiseMods} from "./raiseMods";
import updChar from "../../_sig_api/updChar";
import data_disziplinen from "../../_data/disziplinen";

interface IProp {
    edit: string,
    isOpen: (open: string) => void
}

function DisziplinesEdit({edit, isOpen}: IProp) {
    const [discipline, setDiscipline] = useState<ICharDiscipline | null>(null)

    const [canRaise, setCanRaise] = useState(false)
    const [canRaiseMsg, setCanRaiseMsg] = useState('')
    const [nextCircle, setNextCircle] = useState(0)

    const [newTalents, setNewTalents] = useState<ICharTalent[]>([])
    const [optionalTalents, setOptionalTalents] = useState<ICharTalent[]>([])
    const [optionalTalent, setOptionalTalent] = useState('')

    useEffect(() => {
        console.log('DisziplinesEdit', edit)
        const fd = s_char_disciplines.value.find(d => d.id == edit)
        if (fd) {
            setDiscipline(fd)
            checkRaise(fd)
        } else setDiscipline(null)
    }, [edit])


    const checkRaise = (charDiscipline: ICharDiscipline) => {
        setNewTalents([]);
        setOptionalTalents([])
        setOptionalTalent('');

        if (!charDiscipline) return false;

        const currentCircle = charDiscipline.circle
        const newCircle = charDiscipline.circle + 1;

        setNextCircle(newCircle);

        const raise = Charcreate.disciplineRaise.find(r => r.new === newCircle);

        if (!raise) return false;

        const discipline = data_disziplinen.find(d => d.name == charDiscipline.name)
        let checkTalents: string[] = []
        if (discipline) {
            for (let i = 1; i <= currentCircle; i++) {
                checkTalents = checkTalents.concat(discipline.TuF[i].talente)
            }
            discipline.TuF.optionen.forEach(option => {
                if (option.f >= currentCircle && option.t <= currentCircle) {
                    checkTalents.concat(option.talente)
                }
            })
        }
        let talents = s_char_talents.value.filter(t => checkTalents.includes(t.name));
        let amountStep = 0, highest = 0;
        for (let i = 0; i < talents.length; i++) {
            const t = talents[i];
            if (!talents[i].free) {
                highest = talents[i].step > highest ? talents[i].step : highest;
                if (t.step >= raise.minStep) {
                    amountStep++
                }
            }
        }

        const high = highest >= raise.exists;
        const amount = amountStep >= raise.amount;
        if (!(amount && high)) {
            const highTxt = !high ? '1 Talent aus dem Kreis ' + raise.exists : '';
            let amountTxt = !amount ? 'mindestens ' + raise.amount + ' Talente auf Stufe ' + raise.minStep : '';
            if (highTxt !== '' && amountTxt !== '') amountTxt = ' und ' + amountTxt;
            const msg = 'Steigern nicht möglich: ' + highTxt + amountTxt + ' benötigt';
            setCanRaise(false);
            setCanRaiseMsg('Bedingungen nicht erfüllt: ' + msg)
            return false;
        }

        const currentTalents = s_char_talents.value.map(t => t.name);

        setCanRaise(true);
        setCanRaiseMsg('Bedingungen erfüllt')

        const newtalents = DisziplineTalents.getTalente(s_char.value.id, charDiscipline.name, newCircle);

        let create: ICharTalent[] = [];
        let optionals: ICharTalent[] = [];
        newtalents.forEach(t => {
            if (!currentTalents.includes(t.name)) {
                if (t.optional) optionals.push(t)
                else create.push(t)
            }
        })
        setOptionalTalents(optionals);
        setNewTalents(create)

        return true;
    }

    const raise = () => {
        if (!canRaise) return;
        if (!discipline) return;
        if (!optionalTalent) return;

        const newCircle = discipline!.circle + 1;

        const newtalents = DisziplineTalents.getTalente(s_char.value.id, discipline.name, newCircle);

        const newOptional = newtalents.find(t => t.name === optionalTalent)

        const currentTalents = s_char_talents.value;

        let addTalents:ICharTalent[] = [];
        let updateTalents: ICharTalent[] = [];
        newtalents.forEach(t => {
            if (!t.optional && !(currentTalents.map(ct=>ct.name).includes(t.name))) {
                addTalents.push(t)
            } else {
                let fct = currentTalents.find(ct => ct.name == t.name)
                if (fct) {
                    fct.discipline = fct.discipline + ',' + discipline.name
                    updateTalents.push(fct)
                }
            }
        })
        if (newOptional) {
            addTalents.push(newOptional);
        }

        TalentsCreate(addTalents)

        let talents = s_char_talents.value;

        if (newCircle === 5) {
            if (['Magier', 'Elementarist', 'Geisterbeschwörer', 'Illusionist'].includes(discipline!.name)) {
                for (let i = 0; i < talents.length; i++) {
                    if (talents[i].free && talents[i].name === 'Standardmatrix') {
                        talents[i].name = 'Erweiterte Matrix';
                        updateTalents.push(talents[i])
                        let matrix = s_char_matrices.value.find(m => m.tid === talents[i].id)
                        if (matrix) {
                            matrix.name = 'Erweiterte Matrix'
                            matrix.splittable = true
                            MatricesUpdate(matrix)
                            s_char_matrices.value = s_char_matrices.value.map(m => {
                                if (matrix && m.id === matrix.id) return matrix
                                else return m
                            })
                        }
                        break
                    }
                }
            }
        }

        for (let i = 0; i < talents.length; i++) {
            if (talents[i].discipline === discipline?.name && talents[i].free) {
                talents[i].step = newCircle;
                talents[i].stepfree = newCircle;
                updateTalents.push(talents[i])
            }
        }

        let char_talents = s_char_talents.value.concat(addTalents);

        if (updateTalents.length > 0) {
            TalentsUpdate(updateTalents)
            updateTalents.forEach(ut => {
                char_talents = char_talents.map(ct => {
                    if (ct.id == ut.id) return ut
                    return ct
                })
            })
        }

        s_char_talents.value = char_talents

        console.log('/char/discipline update', {id: discipline.id, circle: newCircle})
        DisciplinesUpdate({id: discipline.id, circle: newCircle})
        s_char_disciplines.value = s_char_disciplines.value.map(d => {
            if (d.name == discipline.name) {
                d.circle = newCircle
            }
            return d
        })

        let charUpd = getBaseCharUpd();
        updChar(charUpd)

        raiseMods(discipline, newCircle);

        isOpen('')
    }

    return <Fragment>
        <Dialog open={edit !== ''}>
            <DialogContent>
                <div key={'dedc1'}>
                    {discipline?.num === 1 ? 'Erste ' : null}
                    {discipline?.num === 2 ? 'Zweite ' : null}
                    {discipline?.num === 3 ? 'Dritte ' : null}
                    Disziplin: {discipline?.name}
                </div>
                {!canRaise ?
                    <div>{canRaiseMsg}</div>
                    :
                    <Fragment>
                        <div key={'dedc2'} style={{marginTop: '6px'}}>
                            Neue Talente:
                            <ul style={{marginTop: '6px'}}>
                                {newTalents.map((t, i) => <li key={'nTM' + i}>{t.name}</li>)}
                            </ul>
                        </div>
                        <div key={'dedc3'} style={{marginTop: '6px'}}>
                            <div key={'dedc4'}>Optionales Talent:</div>
                            <Select value={optionalTalent || ''}
                                    onChange={(e) => setOptionalTalent(e.target.value)}
                                    variant="standard"
                            >
                                {optionalTalents.map((t, i) => <MenuItem key={'oTN' + i}
                                                                         value={t.name}>{t.name}</MenuItem>)}
                            </Select>
                        </div>
                    </Fragment>}
            </DialogContent>
            <DialogActions>
                <Button disabled={!canRaise || !optionalTalent} onClick={() => raise()}><ArrowUpwardIcon/></Button>
                <Button onClick={() => isOpen('')}><ClearIcon/></Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default DisziplinesEdit
